<ng-container *ngFor="let item of items">
    <div class="text-white" 
        [ngClass]="item?.alignment" 
        [style.padding-top.px]="item?.padding"
        [style.padding-bottom.px]="item?.padding" 
        *ngIf="item?.type == 'HEADING'" 
        [innerHTML]="item?.content">
    </div>

    <div class="text-white">
        <div class="d-block mx-auto font-size-16" style="max-width: 700px;"
            [ngClass]="item?.alignment" 
            [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" 
            *ngIf="item?.type == 'TEXTAREA'" 
        >
            {{ item?.content }}
        </div>
    </div>

</ng-container>

<div class="row mt-5 mb-5 mx-0">
    <div class="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-4 offset-md-2 offset-lg-3 offset-xl-4">
        <div class="input-group mb-3 bg-white rounded p-2">
            <input style="border: none;" type="text" (keyup)="filterByTitle()" [(ngModel)]="title"
                placeholder="Search ..." aria-label="Search ..." aria-describedby="form-search"
                class="font-size-16 form-control">
            <div class="input-group-append px-5">
                <!--<img loading="lazy" src="assets/img/icons/icn-nav-arrow-right.svg" />-->
                <i class="material-symbols-outlined">search</i>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12 text-center">
        <div class="d-inline-block board-tag cursor-pointer mb-3" [class.active]="activeFilter == 'All'"
            (click)="filterPosts('All')">
            <a [routerLink]="['/notice-board/']" [queryParams]="{tag: 'All'}">All</a>
        </div>
        <div class="d-inline-block board-tag cursor-pointer mb-3" [class.active]="activeFilter == filter"
            *ngFor="let filter of filters" (click)="filterPosts(filter)">
            <a [routerLink]="['/notice-board/']" [queryParams]="{tag: filter}">
                {{ filter }}
            </a>
        </div>
    </div>
</div>